export default __webpack_public_path__ + "static/media/background.20e372c4.jpg";